import { FC, ReactNode } from "react";
import { CustomerSettingsContext } from "./CustomerSettingsContext";
import { CustomerSettingsLoader } from "./CustomerSettingsLoader";
import { CustomerSettingsDto } from "./CustomerSettings";
import { UseQueryResult } from "@tanstack/react-query";

export const CustomerSettingsContextProvider: FC<{
  children: (
    customerSettingsQueryResult: UseQueryResult<CustomerSettingsDto>
  ) => ReactNode;
}> = (props) => {
  return (
    <CustomerSettingsLoader>
      {(queryResult) => {
        return (
          <CustomerSettingsContext.Provider value={queryResult.data}>
            {props.children(queryResult)}
          </CustomerSettingsContext.Provider>
        );
      }}
    </CustomerSettingsLoader>
  );
};
